module.exports = __webpack_public_path__ + "img/share-04.c0bfb936.svg";